import { View, h3, Button, fromTheme, styled, Pressable, webOnlyStyles } from 'lib_ui-primitives';

let _CaratButton = styled(Pressable).attrs({ name: 'carat-button' })`
    padding: ${fromTheme('button', 'padding')};
`;
_CaratButton.displayName = 'CaratButton';
_CaratButton = webOnlyStyles(_CaratButton)`
    min-width: fit-content;
`;

export const CaratButton = _CaratButton;
export const CollapseAllButton = styled(Button).attrs({ name: 'collapse-all-button' })`
    padding: ${fromTheme('button', 'padding')};
`;
CollapseAllButton.displayName = 'CollapseAllButton';

export const ExpandAllButton = styled(Button).attrs({ name: 'expand-all-button' })`
    padding: ${fromTheme('button', 'padding')};
`;
let _ExpandCollapseButtons = styled(View).attrs({ name: 'expand-collapse-buttons' })`
    flex-direction: row;
    justify-content: flex-end;
    flex-grow: 1;
`;
_ExpandCollapseButtons.displayName = 'ExpandCollapseButtons';
_ExpandCollapseButtons = webOnlyStyles(_ExpandCollapseButtons)`
    min-width: fit-content;
`;
export const ExpandCollapseButtons = _ExpandCollapseButtons;

export const StyledEditableList = styled(View).attrs({ name: 'editable-list' })`
    flex-direction: column;
    padding: 0;
    flex-basis: 100%;
    margin-right: ${fromTheme('editableList', 'margin')};
`;
StyledEditableList.displayName = 'StyledEditableList';
export const Header = styled(View).attrs({ name: 'header' })`
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    min-width: 280px;
    border-bottom: ${fromTheme('editableList', 'header', 'bottomBorder')};
    padding-bottom: ${fromTheme('editableList', 'header', 'bottomPadding')};
    margin-bottom: ${fromTheme('editableList', 'margin')};
`;
Header.displayName = 'Header';
export const ListTitle = styled(h3).attrs({ name: 'list-title' })`
    padding-left: ${fromTheme('viewPadding')};
    color: ${fromTheme('subheadingFontColor')};
    font-family: ${fromTheme('font')};
`;
ListTitle.displayName = 'ListTitle';
export const ColumnList = styled(View).attrs({ name: 'column-list' })`
    flex-direction: column;
    flex-basis: 100%;
    gap: ${fromTheme('editableList', 'margin')};
`;
ColumnList.displayName = 'ColumnList';
